import { SSOLoginResponse } from '@/types/loginResponse'
import { AuthenticationResult } from '@/types/authenticationResult'
import { OtpState } from '@/types/otpState'
import { MFAMethod } from './mfa'

type TotpHttpLogin = (username: string, session: string, code: string, mfa_type?: MFAMethod) => Promise<SSOLoginResponse>
type RedirectToRetrieveToken = (authenticationResult: AuthenticationResult) => Promise<void>
type ChallengeHandler = (username: string, loginResponse: SSOLoginResponse, redirectUrlAfterLogin: string) => void
type UpdatePasswordHandler = (accessToken: string, redirectUrlAfterLogin: string) => void

const state: OtpState = {
  username: undefined,
  session: undefined,
  code: undefined,
  deliveryMedium: undefined,
  sentTo: undefined,
  redirectUrlAfterLogin: undefined
}

export const isOtpInitialized = () => {
  return state.session !== undefined && state.username !== undefined && state.redirectUrlAfterLogin !== undefined
}

export const initOtp = (username: string, session: string, deliveryMedium: string, sentTo: string, redirectUrlAfterLogin: string) => {
  state.username = username
  state.session = session
  state.deliveryMedium = deliveryMedium
  state.sentTo = sentTo
  state.redirectUrlAfterLogin = redirectUrlAfterLogin
}

export const otpLoginFlow = (totpLoginHttp: TotpHttpLogin, redirectToRetrieveToken: RedirectToRetrieveToken, challengeHandler: ChallengeHandler, updatePasswordHandler: UpdatePasswordHandler) =>
  async (code: string) => {
    if (!state.session || !state.username || !state.redirectUrlAfterLogin) {
      throw Error('Must set username and session before login with otp')
    }

    const mfa_type = state.deliveryMedium === 'SMS'
      ? MFAMethod.SMS
      : MFAMethod.Email

    const loginResponse = await totpLoginHttp(state.username, state.session, code, mfa_type)

    if (loginResponse.code === 'PasswordExpired' && !loginResponse.mfaRequired) {
      // We set the email and accessToken in the sessionStorage just to uses it in the changePassword in case the user do a refresh in the page.
      window.sessionStorage.setItem('email', state.username)
      window.sessionStorage.setItem('accessToken', loginResponse.accessToken)

      return updatePasswordHandler(loginResponse.accessToken, state.redirectUrlAfterLogin)
    }

    loginResponse.ChallengeName
      ? challengeHandler(state.username, loginResponse, state.redirectUrlAfterLogin)
      : redirectToRetrieveToken(loginResponse.AuthenticationResult)
  }

export const getOtpState = () => state
